import { useQuery } from '@tanstack/react-query';
import api from '../../lib/api';

/** One election milestone type (election_milestone_types) as the API serves it. */
export interface MilestoneType {
  value: string;
  label: string;
  description: string | null;
  category: string;
  citizen_visible: boolean;
  notify_by_default: boolean;
  citizen_reminder_lead_days: number[];
  reminder_message: string | null;
  reminder_link_url: string | null;
  default_sort_order: number;
  is_system: boolean;
  active: boolean;
  usage_count: number;
  upcoming_count: number;
  upcoming_notifying_count: number;
}

export const MILESTONE_TYPES_QUERY_KEY = ['admin-elections', 'milestone-types'] as const;

/**
 * The milestone type vocabulary (Documentation/ELECTION_MILESTONE_TYPES_PRD.md).
 * Admin-managed, so it comes from the API — never a frontend constant.
 * `includeRetired` adds retired types (the Milestone Types tab lists them; the
 * Add Milestone dropdown does not).
 */
export function useMilestoneTypes({ includeRetired = false }: { includeRetired?: boolean } = {}) {
  return useQuery({
    queryKey: [...MILESTONE_TYPES_QUERY_KEY, includeRetired],
    queryFn: async () => {
      const response = await api.get('/election-milestone-types', {
        params: includeRetired ? { include_retired: 'true' } : undefined,
      });
      return (response.data.data ?? []) as MilestoneType[];
    },
    staleTime: 5 * 60 * 1000,
  });
}
